var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVehicles = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 595.498"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M472.93 109.58l-58.94-17.83-.1-.1-40.505-20.727L352.93 30 327.67 4.45A15.067 15.067 0 00317 0H106.69a14.988 14.988 0 00-13.37 8.21L51.8 89.93H35a35.038 35.038 0 00-35 35V151l10 14.077L0 181v3.23a55.061 55.061 0 0054.89 55H497a15.005 15.005 0 0015-15v-62a54.685 54.685 0 00-39.07-52.65z",
  fill: "#ffe478"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M512 162.23v62a15.005 15.005 0 01-15 15H241.88V0H317a15.067 15.067 0 0110.67 4.45L352.93 30l20.45 40.92 40.51 20.73.1.1 58.94 17.83A54.685 54.685 0 01512 162.23z",
  fill: "#ffca0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M413.89 91.65l-277.23-.51a15.121 15.121 0 01-15.08-15.13l.061-31.039a15 15 0 0115-14.971H352.93z",
  fill: "#91e0fc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5",
  d: "M413.89 91.65l-172.01-.32V30h111.05z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12",
  d: "M512 162.23v17.36h-49a15 15 0 010-30h47.56a55.539 55.539 0 011.44 12.64z",
  fill: "#ff9803"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13",
  d: "M121.692 178.692a61.153 61.153 0 1061.154 61.153 61.224 61.224 0 00-61.154-61.153z",
  fill: "#465a61"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 14",
  d: "M121.692 271a31.154 31.154 0 1131.154-31.154A31.19 31.19 0 01121.692 271z",
  fill: "#f0f0f7"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 15",
  d: "M391.231 178.692a61.153 61.153 0 1061.154 61.153 61.224 61.224 0 00-61.154-61.153z",
  fill: "#2f4247"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 16",
  d: "M391.231 271a31.154 31.154 0 1131.154-31.154A31.19 31.19 0 01391.231 271z",
  fill: "#e6e7f5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 17",
  d: "M46 166a15.005 15.005 0 01-15 15H0v-30h31a15.005 15.005 0 0115 15z",
  fill: "#ed6c7b"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "auto_cc"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M472.93 253.579l-58.94-17.83-.1-.1-40.505-20.727-20.455-40.923-25.26-25.55a15.067 15.067 0 00-10.67-4.45H106.69a14.988 14.988 0 00-13.37 8.21l-41.52 81.72H35a35.038 35.038 0 00-35 35v26.07l10 14.077-10 15.923v3.23a55.061 55.061 0 0054.89 55H497a15.005 15.005 0 0015-15v-62a54.685 54.685 0 00-39.07-52.65z",
  fill: "#ed6c7b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M512 306.229v62a15.005 15.005 0 01-15 15H241.88v-239.23H317a15.067 15.067 0 0110.67 4.45l25.26 25.55 20.45 40.92 40.51 20.73.1.1 58.94 17.83a54.685 54.685 0 0139.07 52.65z",
  fill: "#e21959"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M413.89 235.649l-277.23-.51a15.121 15.121 0 01-15.08-15.13l.061-31.039a15 15 0 0115-14.971H352.93z",
  fill: "#91e0fc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5",
  d: "M413.89 235.649l-172.01-.32v-61.33h111.05z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12",
  d: "M512 306.229v17.36h-49a15 15 0 010-30h47.56a55.539 55.539 0 011.44 12.64z",
  fill: "#ff9803"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13",
  d: "M121.692 322.691a61.153 61.153 0 1061.154 61.153 61.224 61.224 0 00-61.154-61.153z",
  fill: "#465a61"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 14",
  d: "M121.692 414.999a31.154 31.154 0 1131.154-31.154 31.19 31.19 0 01-31.154 31.154z",
  fill: "#f0f0f7"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 15",
  d: "M391.231 322.691a61.153 61.153 0 1061.154 61.153 61.224 61.224 0 00-61.154-61.153z",
  fill: "#2f4247"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 16",
  d: "M391.231 414.999a31.154 31.154 0 1131.154-31.154 31.19 31.19 0 01-31.154 31.154z",
  fill: "#e6e7f5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 17",
  d: "M46 309.999a15.005 15.005 0 01-15 15H0v-30h31a15.005 15.005 0 0115 15z",
  fill: "#ffe478"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "auto_cc"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M472.93 404.078l-58.94-17.83-.1-.1-40.505-20.727-20.455-40.923-25.26-25.55a15.067 15.067 0 00-10.67-4.45H106.69a14.988 14.988 0 00-13.37 8.21l-41.52 81.72H35a35.038 35.038 0 00-35 35v26.07l10 14.077-10 15.923v3.23a55.061 55.061 0 0054.89 55H497a15.005 15.005 0 0015-15v-62a54.685 54.685 0 00-39.07-52.65z",
  fill: "#cdebfc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M512 456.728v62a15.005 15.005 0 01-15 15H241.88v-239.23H317a15.067 15.067 0 0110.67 4.45l25.26 25.55 20.45 40.92 40.51 20.73.1.1 58.94 17.83a54.685 54.685 0 0139.07 52.65z",
  fill: "#bfe1fd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M413.89 386.148l-277.23-.51a15.121 15.121 0 01-15.08-15.13l.061-31.039a15 15 0 0115-14.971H352.93z",
  fill: "#91e0fc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5",
  d: "M413.89 386.148l-172.01-.32v-61.33h111.05z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12",
  d: "M512 456.728v17.36h-49a15 15 0 010-30h47.56a55.539 55.539 0 011.44 12.64z",
  fill: "#ff9803"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13",
  d: "M121.692 473.19a61.153 61.153 0 1061.154 61.153 61.224 61.224 0 00-61.154-61.153z",
  fill: "#465a61"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 14",
  d: "M121.692 565.498a31.154 31.154 0 1131.154-31.154 31.19 31.19 0 01-31.154 31.154z",
  fill: "#f0f0f7"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 15",
  d: "M391.231 473.19a61.153 61.153 0 1061.154 61.153 61.224 61.224 0 00-61.154-61.153z",
  fill: "#2f4247"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 16",
  d: "M391.231 565.498a31.154 31.154 0 1131.154-31.154 31.19 31.19 0 01-31.154 31.154z",
  fill: "#e6e7f5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 17",
  d: "M46 460.498a15.005 15.005 0 01-15 15H0v-30h31a15.005 15.005 0 0115 15z",
  fill: "#ed6c7b"
})))));
export default SvgVehicles;